import { render, staticRenderFns } from "./PanelInfo.vue?vue&type=template&id=2fa44014&scoped=true&"
import script from "./PanelInfo.vue?vue&type=script&lang=ts&"
export * from "./PanelInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PanelInfo.vue?vue&type=style&index=0&id=2fa44014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa44014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2fa44014', component.options)
    } else {
      api.reload('2fa44014', component.options)
    }
    module.hot.accept("./PanelInfo.vue?vue&type=template&id=2fa44014&scoped=true&", function () {
      api.rerender('2fa44014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/reusables/PanelInfo.vue"
export default component.exports